<div class="ws-section">
    <div class="ws-section__header">
        <h4 class="ws-section__header__title">
            Database Processes
            <ag-grid-row-count [gridApi]="gridApi" [gridTracker]="gridTracker" [gridOptions]="gridOptions"></ag-grid-row-count>
        </h4>
        @if (isInitialized) {
            <div class="ws-section__header__actions">
                <div class="ws-section__header__actions__item">
                    <button type="button"
                            class="ace-btn btn-sm btn-primary"
                            (click)="clearCacheEntry()"
                            [disabled]="loadingData"
                            position="bottom">
                        Clear Cache Entry
                    </button>
                    <button type="button"
                            class="ace-btn btn-sm btn-primary"
                            (click)="clearCache()"
                            [disabled]="loadingData"
                            position="bottom">
                        Clear Cache (All)
                    </button>
                    <button type="button"
                            class="ace-btn btn-sm btn-secondary has-icon"
                            (click)="refresh()"
                            [disabled]="loadingData"
                            helpTooltip
                            helpContentId="app.refresh"
                            position="bottom">
                        <i class="fa fa-refresh"></i>
                    </button>
                </div>
            </div>
        }
    </div>
</div>
<ws-ag-grid-angular [gridOptions]="gridOptions"
                    (gridReady)="onAgGridReady($event)"
                    [gridId]="gridId"
                    [isBulkDeleteVisible$]="isBulkDeleteVisible$"
                    (bulkDelete)="bulkKill()">
</ws-ag-grid-angular>
